<template>
  <div class="hg" :style="getColumns()" >
    <div class="txt" v-for="(wave, index) in waves" :key="index">
      <div>{{ wave.name }} {{ wave.year }}</div>
      <span class="subtxt">n={{ getCount(wave) }}</span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    kpi: { type: Object, default: undefined },
    history: { type: Array },
    waves: { type: Array, required: true  }
  },

  methods: {
    getColumns() {
      return { 'grid-template-columns': '1fr '.repeat(this.waves.length) };
    },

    getCount(wave) {
      let data = this.kpi.SurveyWave?.find(x => x.Year === wave.year && x.quarter === wave.name);
      return data?.NumberOfShopsTotal ?? 0;
    }
  }
};

</script>

<style scoped>

  .hg {
    display: grid;
    width: 100%;
    text-align: center;
    font-size:8pt;
    line-height: 0.75rem;
    grid-template-rows: 2rem;
  }

  .txt {
    padding-top: 0.25rem;
    letter-spacing: 0em;
    font-weight: bold;
    text-transform: uppercase;
  }

  .subtxt {
    padding-top: 0.25rem;
    letter-spacing: 0em;
    font-weight: 300;
    text-transform: lowercase;
  }

</style>
